module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZDUyYjFlIiBkPSJNMCAwaDY0MHY0ODBIMHoiLz4KICAgIDxnIGZpbGw9IiNmZmYiPgogICAgICA8cGF0aCBkPSJNMTcwIDE5NC45OTdoMjk5Ljk5NnY4OS45OTdIMTcweiIvPgogICAgICA8cGF0aCBkPSJNMjc1IDg5Ljk5N2g4OS45OTZ2Mjk5Ljk5NkgyNzV6Ii8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ch.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ch.svg
// module chunks = 0